// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { CSSTransitionGroup  } from 'react-transition-group';
import './Modal.scss';

@inject('modalStore')
@observer class Modal extends Component<any, any> {

	constructor(props: any) {
		super(props);

		this.close = this.close.bind(this);
	}

	close(): void {
		this.props.modalStore.removeModal();
	}

	render() {
		return (
			<CSSTransitionGroup  
				transitionName="animate-modal"
				transitionEnterTimeout={300}
				transitionLeaveTimeout={300}>
				{this.props.modalStore.headline && 
				this.props.modalStore.headline !== '' && 
				this.props.modalStore.content ? 
					<div className="modal" onClick={this.close}>
							<div className="modal-overlay">
								<div className="modal-body" onClick={(e) => e.stopPropagation()}>
									<div className="modal-header">
										<h2>{this.props.modalStore.headline}</h2>
										<i className="icon-times" onClick={this.close}></i>
									</div>
									<div className="modal-content">
										{this.props.modalStore.content}
									</div>
								</div>
							</div>
					</div>
					: null
				}
			</CSSTransitionGroup>
		)
	}
}

export default Modal;